import { useState } from "react";
import { CommerceDialog } from "../../commerce/CommerceDialog";
import { listaMaquininhas, MAX_PARCELAS } from "../../../constants/maquininhas";
import { Icone } from "./Icone";

/* Maquininha (pagamentos presenciais no PDV). As taxas servem para calcular
   quanto cobrar do cliente para a taxa não sair do bolso do vendedor. O
   formato salvo (paymentConfig.maquininhas / maquininhaPadraoId) é o mesmo que
   PDV, Pedidos, Vendas online e a calculadora de cartão leem. */

const COR = "#0ea5e9";
const pct = v => (v === "" || v === undefined || v === null ? "—" : `${String(v).replace(".", ",")}%`);
const creditos = m => (Array.isArray(m?.credito) && m.credito.length === MAX_PARCELAS ? m.credito : Array(MAX_PARCELAS).fill(""));

export function LinhaMaquininha({ cfg, onVerTaxas, onConfigurar }) {
  const lista = listaMaquininhas(cfg);
  const padrao = lista.find(m => m.id === cfg.maquininhaPadraoId);
  const personalizadas = Array.isArray(cfg.maquininhas) && cfg.maquininhas.length > 0;
  return (
    <li className="pgw-item" style={{ "--gw-cor": COR }}>
      <div className="pgw-logo"><Icone nome="maquininha" /></div>
      <div className="pgw-texto">
        <div className="pgw-titulo"><span className="pgw-nome">Maquininha</span></div>
        <div className="pgw-sub">
          {personalizadas ? `${lista.length} ${lista.length === 1 ? "maquininha" : "maquininhas"}` : "Taxas de referência"}
          {padrao ? <> · padrão no PDV: <b>{padrao.nome || "sem nome"}</b></> : null}
        </div>
      </div>
      <div className="pgw-acoes">
        <button type="button" className="pgw-btn texto" onClick={onVerTaxas}>Ver taxas</button>
        <button type="button" className="pgw-btn" onClick={onConfigurar}>Configurar</button>
      </div>
    </li>
  );
}

export function JanelaTaxas({ cfg, onConfigurar, onClose }) {
  const lista = listaMaquininhas(cfg);
  return (
    <CommerceDialog className="pgw-dialogo largo" title="Taxas das maquininhas" subtitle="Referência para o preço no PDV — confira a taxa real no app da maquininha" onClose={onClose}
      footer={<>
        <button type="button" className="pgw-btn" onClick={onClose}>Fechar</button>
        <button type="button" className="pgw-btn primario" style={{ "--b-cor": COR }} onClick={onConfigurar}>Editar taxas</button>
      </>}>
      <div className="pgw-tabela-rolagem">
        <table className="pgw-tabela">
          <thead><tr><th scope="col">Maquininha</th><th scope="col">Débito</th>{Array.from({ length: MAX_PARCELAS }, (_, i) => <th key={i} scope="col">{i + 1}x</th>)}</tr></thead>
          <tbody>
            {lista.map(m => (
              <tr key={m.id}>
                <th scope="row">{m.nome || "Sem nome"}{cfg.maquininhaPadraoId === m.id ? " · padrão" : ""}</th>
                <td>{pct(m.debito)}</td>
                {creditos(m).map((v, i) => <td key={i}>{pct(v)}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CommerceDialog>
  );
}

export function JanelaMaquininhas({ cfg, salvar, onClose }) {
  const [lista, setLista] = useState(() => listaMaquininhas(cfg).map(m => ({ ...m, credito: [...creditos(m)] })));
  const [padrao, setPadrao] = useState(cfg.maquininhaPadraoId || "");
  const [ocupado, setOcupado] = useState(false);
  const [erro, setErro] = useState("");

  const upd = (id, patch) => setLista(l => l.map(m => (m.id === id ? { ...m, ...patch } : m)));
  const updParcela = (id, idx, valor) => setLista(l => l.map(m => {
    if (m.id !== id) return m;
    const credito = [...m.credito];
    credito[idx] = valor;
    return { ...m, credito };
  }));
  const adicionar = () => setLista(l => [...l, { id: `m${Date.now()}`, nome: "", debito: "", credito: Array(MAX_PARCELAS).fill("") }]);
  const remover = id => { setLista(l => l.filter(m => m.id !== id)); if (padrao === id) setPadrao(""); };

  async function enviar() {
    const negativa = lista.some(m => Number(m.debito) < 0 || m.credito.some(v => Number(v) < 0));
    if (negativa) { setErro("As taxas não podem ser negativas."); return; }
    setOcupado(true);
    const ok = await salvar({ maquininhas: lista, maquininhaPadraoId: lista.some(m => m.id === padrao) ? padrao : "" });
    setOcupado(false);
    if (ok) onClose(); else setErro("Não foi possível salvar. Tente de novo.");
  }

  return (
    <CommerceDialog className="pgw-dialogo largo" title="Maquininhas" subtitle="Taxas para calcular quanto cobrar do cliente no PDV" onClose={() => !ocupado && onClose()}
      footer={<>
        <button type="button" className="pgw-btn texto commerce-secondary" onClick={adicionar} disabled={ocupado}>+ Adicionar maquininha</button>
        <button type="button" className="pgw-btn" onClick={onClose} disabled={ocupado}>Cancelar</button>
        <button type="button" className="pgw-btn primario" style={{ "--b-cor": COR }} onClick={enviar} disabled={ocupado}>
          {ocupado ? <><span className="pgw-spin" aria-hidden="true" /> Salvando…</> : "Salvar"}
        </button>
      </>}>
      <div className="pgw-etapa">
        {lista.map((m, n) => (
          <fieldset key={m.id} className="pgw-maq" style={{ margin: 0 }}>
            <legend className="pgw-sr">Maquininha {n + 1}</legend>
            <div className="pgw-maq-topo">
              <label className="pgw-campo">Nome
                <input value={m.nome} onChange={e => upd(m.id, { nome: e.target.value })} placeholder="Ex.: Mercado Pago" />
              </label>
              <label className="pgw-campo">Débito %
                <input type="number" inputMode="decimal" step="0.01" min="0" value={m.debito} onChange={e => upd(m.id, { debito: e.target.value })} placeholder="1,99" />
              </label>
              <div className="pgw-acoes" style={{ paddingBottom: 3 }}>
                <label className="pgw-radio"><input type="radio" name="pgw-maq-padrao" checked={padrao === m.id} onChange={() => setPadrao(m.id)} /> Padrão no PDV</label>
                <button type="button" className="pgw-btn texto perigo" onClick={() => remover(m.id)} aria-label={`Remover ${m.nome || "maquininha"}`}>Remover</button>
              </div>
            </div>
            <div className="pgw-parcelas" role="group" aria-label={`Crédito parcelado — ${m.nome || "maquininha"}`}>
              {m.credito.map((v, i) => (
                <label key={i}>{i + 1}x
                  <input type="number" inputMode="decimal" step="0.01" min="0" value={v} onChange={e => updParcela(m.id, i, e.target.value)} aria-label={`Crédito ${i + 1}x (%)`} />
                </label>
              ))}
            </div>
          </fieldset>
        ))}
        {!lista.length && <p>Nenhuma maquininha. Sem nenhuma, o PDV usa as taxas de referência.</p>}
        {erro && <div className="pgw-erro" role="alert">{erro}</div>}
      </div>
    </CommerceDialog>
  );
}
